import React, { FC } from 'react';
import { ReactComponent as ClientLinks } from '../../../assets/MainMenu/ClientLinks.svg';

export const ClientLinksIcon: FC = () => <ClientLinks />;
